module.exports = __webpack_public_path__ + "img/fuminyinhang.a60a1c03.png";